module.exports = __webpack_public_path__ + "static/media/Telus_One_page-27.be6b94d4.png";